'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIList from 'UIComponents/list/UIList';
import UIToggle from 'UIComponents/input/UIToggle';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIFlex from 'UIComponents/layout/UIFlex';
import { device } from '../../constants/StyledComponentConstants';
const UIFlexContainer = styled(UIFlex).withConfig({
  displayName: "VideoControls__UIFlexContainer",
  componentId: "z4wm62-0"
})(["border-bottom-left-radius:3px;border-bottom-right-radius:3px;"]);
const StyledUIButton = styled(UIButton).withConfig({
  displayName: "VideoControls__StyledUIButton",
  componentId: "z4wm62-1"
})(["@media screen and ", "{margin-top:8px;}"], device.mobile);

const VideoControls = ({
  autoPlay,
  onFinish,
  onToggleAutoPlay,
  playSpeed,
  onSetPlaySpeed
}) => {
  return /*#__PURE__*/_jsxs(UIFlexContainer, {
    direction: "row",
    justify: "between",
    wrap: "wrap",
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(UIFormLabel, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.videoControls.autoPlay"
        }), /*#__PURE__*/_jsx(UIToggle, {
          checked: autoPlay,
          className: "m-left-3",
          id: "toggle-button",
          onChange: onToggleAutoPlay,
          size: "extra-small"
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx("span", {
            className: "m-right-3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.videoControls.playSpeed"
            })
          }), /*#__PURE__*/_jsx(UIDropdown, {
            buttonText: `${playSpeed}%`,
            buttonUse: "link",
            menuWidth: "auto",
            style: {
              width: 'auto'
            },
            children: /*#__PURE__*/_jsx(UIList, {
              children: [50, 100, 125, 150, 200].map(value => {
                return /*#__PURE__*/_jsxs(UIButton, {
                  onClick: () => onSetPlaySpeed(value),
                  use: "link",
                  children: [value, "%"]
                }, value);
              })
            })
          })]
        })
      })
    }), !!onFinish && /*#__PURE__*/_jsx(StyledUIButton, {
      onClick: onFinish,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.common.next"
      })
    })]
  });
};

VideoControls.propTypes = {
  autoPlay: PropTypes.bool.isRequired,
  onFinish: PropTypes.func.isRequired,
  onSetPlaySpeed: PropTypes.func.isRequired,
  onToggleAutoPlay: PropTypes.func.isRequired,
  playSpeed: PropTypes.number.isRequired
};
export default VideoControls;